import GroupedBetsTable from "../../game-details/GroupedBetsTable";
import { formatOdds, formatAmount } from "../../../utils/formatOdds";
import { latestBets } from "../../../utils/casinoMyBets";

/**
 * My Bets card of the five-cricket pages. Unlike the other casino pages, the reference renders
 * this card as #my-game-bets with the full 6-column table at every width (no "mobile" 3-column
 * variant below 1280px) — so the shared MyBet (which switches on IS_REF_MOBILE) cannot be used as is.
 * Same data/columns/formatting as casinoComponents/myBet.
 */
function formatBetDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

function groupBetsForTable(bets) {
  if (!bets || !bets.length) return [];
  const map = new Map();
  bets.forEach((bet) => {
    const marketType = bet.description ?? bet.market_type ?? bet.marketType ?? "Casino";
    const betType = (bet.game_type ?? bet.bet_type ?? bet.betType ?? bet.type ?? "back").toLowerCase();
    const key = `${marketType}|${betType}`;
    if (!map.has(key)) {
      map.set(key, { marketType, betType, borderClass: betType === "lay" ? "lay-border" : "back-border", bets: [] });
    }
    map.get(key).bets.push(bet);
  });
  const groups = Array.from(map.values());
  groups.forEach((g) => {
    g.bets.sort((a, b) => new Date(b.created_at || b.placeDate || 0) - new Date(a.created_at || a.placeDate || 0));
    g.date = g.bets[0]?.created_at ?? g.bets[0]?.placeDate;
  });
  groups.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
  return groups;
}

const COLUMNS = [
  { key: "username", label: "UserName", headerStyle: { minWidth: "90px" }, getValue: (bet) => bet.username ?? bet.userName ?? bet.user?.username ?? "-" },
  { key: "selection", label: "Nation", headerStyle: { minWidth: "90px" }, getValue: (bet) => bet.selection ?? bet.selection_name ?? bet.matchedBet ?? bet.player_name ?? "-" },
  { key: "odds", label: "Rate", headerClassName: "text-right", headerStyle: { minWidth: "50px" }, className: "text-right", getValue: (bet) => formatOdds(bet.odds ?? bet.userrate) },
  { key: "amount", label: " Amount ", headerClassName: "text-right", headerStyle: { minWidth: "70px" }, className: "text-right", getValue: (bet) => formatAmount(bet.amount ?? bet.stake ?? bet.stake_amount) },
  { key: "placeDate", label: "PlaceDate", headerClassName: "text-right", headerStyle: { minWidth: "70px" }, className: "text-right", getValue: (bet) => formatBetDate(bet.created_at ?? bet.placeDate) || "-" },
  { key: "game_type", label: "Gametype", headerClassName: "text-right", headerStyle: { minWidth: "70px" }, className: "text-right", getValue: (bet) => bet.description ?? bet.market_type ?? bet.marketType ?? "-" },
];

export default function FiveCricketMyBet({ bets = [], onViewMore }) {
  const groups = groupBetsForTable(latestBets(bets)); // latest 10, like the reference
  return (
    <div id="my-game-bets" className="card m-b-10 my-bet">
      <div className="card-header">
        <h6 className="card-title float-left">My Bets</h6>{" "}
        <a
          href="javascript:void(0)"
          className="btn btn-back float-right"
          onClick={(e) => {
            e.preventDefault();
            onViewMore?.();
          }}
        >
          View More
        </a>
      </div>{" "}
      <div className="card-body1">
        <div className="tab-content">
          <div id="matched-bet" className="tab-pane active">
            <div className="table-responsive1">
              <GroupedBetsTable
                columns={COLUMNS}
                groups={groups}
                emptyMessage=" No records found "
                formatDate={formatBetDate}
                tableClassName="table coupon-table mb-0"
                showGroupHeader={false}
                wrapResponsive={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
